import { buildSvgString, type SvgStringOpts } from '../../svgString';

import { data } from './data';

export const MessageSVG = (opts?: SvgStringOpts): string => buildSvgString(data, opts);

export default MessageSVG;
